import { useRef, useEffect, useState } from 'react';
import useResponsiveSize from '../../../hooks/useResponsiveSize';
import { CanvasContext } from '../../../hooks/useCanvas';
import Wave from './Wave';

const Canvas = () => {
  const canvasRef = useRef(null); 
  const { width } = useResponsiveSize();
  const [context, setContext] = useState(); 

  useEffect(() => {
    const canvas = canvasRef.current?.getContext('2d'); 
    if (canvas) setContext(canvas);
  }, []);

  return (
    <CanvasContext.Provider value={{ context }}>
      <canvas id="canvas" ref={canvasRef} width={width} height={220}></canvas>
      <Wave />
    </CanvasContext.Provider>
  );
};

export default Canvas;
